import React, {Component} from 'react';

export default class NoMatch extends Component {
    componentDidMount() {
        document.title = `Page not found - C&A Assembly & Installation Solution`;
    }
    render() {
        return (
            <h1>404 - Page not found</h1>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/NoMatch.js